export const minecraft1182 = {
  version: '1.18.2',
  title: 'Caves & Cliffs Part II',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/CC2_KeyArt_1140x565.jpg',
  releases: [
    {
      id: "1B4DY6fn",
      version: "1.0.4",
      date: "May 10, 2025",
      changelog: "Versión estable para Minecraft 1.18.2, se modifico un mod por otra alternativa",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.18.2",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    },
    {
      id: "1B4DY6fn",
      version: "beta-0.1-1.0.4",
      date: "May 23, 2025",
      changelog: "Versión beta para Minecraft 1.18.2",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.18.2",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    }
  ]
};